<div class="profile-nav-bar" #bar>
  <ul class="nav nav-tabs profile-nav-tabs border-0" role="tablist">
    @for (item of visibleItems(); track item.id; let i = $index) {
      <li class="nav-item" role="presentation" #tab [attr.data-tab-id]="item.id">
        <button
          class="nav-link profile-nav-link"
          type="button"
          role="tab"
          [class.active]="item.active"
          [id]="item.id + '-tab'"
          [attr.aria-controls]="item.id"
          [attr.aria-selected]="item.active"
          [attr.tabindex]="item.active ? 0 : -1"
          (keydown)="onTabKeydown($event, i)"
          (click)="onTabClick(item.id)"
        >
          {{ item.label }}
          @if (item.badge) {
            <span class="badge ms-2 {{ item.badge.styleClass }}">{{ item.badge.label }}</span>
          }
        </button>
      </li>
    }
  </ul>

  @if (overflowItems().length > 0) {
    <div class="dropdown profile-nav-more" #more>
      <button
        class="nav-link profile-nav-link dropdown-toggle"
        type="button"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        More
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
        @for (item of overflowItems(); track item.id) {
          <li>
            <button
              class="dropdown-item d-flex align-items-center justify-content-between gap-2"
              type="button"
              [class.active]="item.active"
              (click)="onOverflowSelect(item.id)"
            >
              <span>{{ item.label }}</span>
              @if (item.badge) {
                <span class="badge {{ item.badge.styleClass }}">{{ item.badge.label }}</span>
              }
            </button>
          </li>
        }
      </ul>
    </div>
  }
</div>
